import React, { useRef } from 'react';
import { Search, X } from 'lucide-react';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
  maxLength?: number;
}

/** Rounded search field with a leading icon and a clear button that refocuses the input. */
export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  maxLength,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-600" />
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={event_ => {
          onChange(event_.target.value);
        }}
        placeholder={placeholder}
        aria-label={ariaLabel}
        maxLength={maxLength}
        className="h-10 w-full rounded-full border border-mb-beige bg-white pl-10 pr-10 text-base placeholder:text-gray-500 focus:border-mb-teal focus:outline-none focus:ring-1 focus:ring-mb-teal-ink"
      />
      {value.length > 0 ? (
        // True 44px hit box (h-11/w-11) centred where the visual ✕ sits, as in WeMetRosterDrawer.
        <button
          type="button"
          onClick={() => {
            onChange('');
            inputRef.current?.focus();
          }}
          aria-label="Clear search"
          className="absolute right-0 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full text-gray-500 transition-colors hover:text-gray-700 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-mb-teal-ink"
        >
          <X className="h-4 w-4" />
        </button>
      ) : null}
    </div>
  );
};
